var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password-before-form"},[_c('div',{staticClass:"title"},[_vm._v("Réinitialisation de votre mot de passe")])])}]

export { render, staticRenderFns }